module.exports = __webpack_public_path__ + "static/media/history_22.e34e3787.jpg";